// Returns the earliest bookable date as YYYY-MM-DD in the local calendar
// of `today`. `leadDays` is whole days (0 = same-day allowed).
//
// TIMEZONE DEPENDENCY: this reads the PROCESS-LOCAL calendar (getFullYear /
// getMonth / getDate), not Europe/Sarajevo. Callers that start from
// todayInZone() (src/lib/emergency-slots.ts and isEmergencySlot() in
// src/lib/emergency.ts) only agree with it because the Dockerfile pins
// TZ=Europe/Sarajevo. Drop that pin (or run this outside the container) and the
// two calendars diverge around midnight, which would shift the emergency /
// regular boundary by a day. Convert this to todayInZone() before relaxing TZ.
export function earliestBookableDate(leadDays: number, today: Date = new Date()): string {
  const d = new Date(today.getFullYear(), today.getMonth(), today.getDate() + leadDays);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
